import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import { useAuth } from "../context/AuthContext";

const CAGlobalSignIn = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const params = new URLSearchParams(window.location.search);
    const username = params.get("username");
    const token = params.get("token");

    window.history.replaceState({}, document.title, window.location.pathname);

    if (!username || !token) {
      navigate("/caglobal/invalid", {
        replace: true,
        state: { reason: "This login link is missing required information." },
      });
      return;
    }

    (async () => {
      try {
        const response = await authService.caGlobalLogin(username, token);
        setUser(response.currentUser);
        navigate("/", { replace: true });
      } catch (err) {
        if (err.status === "NotFound") {
          const created = await authService.caGlobalCreateAccount(username, token);

          if (!created.success) {
            navigate("/caglobal/invalid", {
              replace: true,
              state: { reason: created.error || "We couldn't set up your account automatically." },
            });
            return;
          }

          try {
            const retry = await authService.caGlobalLogin(username, token);
            setUser(retry.currentUser);
            navigate("/", { replace: true });
          } catch (retryErr) {
            navigate("/caglobal/invalid", {
              replace: true,
              state: {
                reason:
                  retryErr.message ||
                  "Your account was created, but automatic sign-in failed. Please try the link again.",
              },
            });
          }
          return;
        }

        navigate("/caglobal/invalid", {
          replace: true,
          state: { reason: err.message || "Automatic sign-in failed." },
        });
      }
    })();
  }, [navigate, setUser]);

  // Render nothing — auth handshake runs silently, user lands directly on dashboard
  return null;
};

export default CAGlobalSignIn;